define([
        'jQuery',
        'underscore',
        'library/fcse-widget/widget',
        'library/fcse-compatibility/object',
        'library/fcse-xslider/jquery.xslider',
        'clientComponents/jquery-touchpunch/jquery.touchpunch'
    ],
    function ($, _, Widget, Object) {

        var RatingSliderRangeFilterWidget = function (selector, options) {
            Widget.call(this, selector, $.extend({
                handleClass: 'selector'
            }, options));

            this._init();

        };

        RatingSliderRangeFilterWidget.prototype = $.extend(Object.create(Widget.prototype), {

            _init: function () {
                var $control = $(this.element);

                var self = this;
                var slider = $control.find('.slider');

                if (!slider.length) return;

                var snaps = _.range(0, 101, 1);

                this._snaps = snaps;
                this._labelMin = $control.find('[data-fcse-role="slider-label-min"]');
                this._labelMax = $control.find('[data-fcse-role="slider-label-max"]');
                this._valuePostfix = $control.data('value-postfix');
                this._maxValue = parseFloat($control.data('max-value'));

                var value;

                // Set value
                if (this.getValue() === null || typeof this.getValue() === 'undefined') {
                    value = [snaps[0], snaps[snaps.length - 1]];
                } else {
                    value = this._convertToSlider(this.getValue());
                }

                slider.xslider({
                    min: parseInt(snaps[0]),
                    max: parseInt(snaps[snaps.length - 1]),
                    values: value,
                    snaps: snaps,
                    range: true,
                    distribution: snaps,
                    slide: function (event, ui) {
                        self._updateLabel(ui.values);
                    },
                    stop: function (event, ui) {
                        var val = self._convertToValue(ui.values);
                        self.setValue(val);
                    },
                    create: function (event, ui) {
                        $('.ui-slider-handle', this).addClass(self.option('handleClass'));
                    }
                });
                this._updateLabel(value);
            },

            _processData: function (value) {
                return value;
            },

            _updateLabel: function (values) {
                var label = '';
                if (this._labelMin.length) {
                    label = values[0];
                    if (this._valuePostfix) {
                        label += this._valuePostfix;
                    }

                    this._labelMin.text(label);
                }
                if (this._labelMax.length) {
                    label = values[1];
                    if (this._valuePostfix) {
                        label += this._valuePostfix;
                    }
                    this._labelMax.text(label);
                }
            },

            setValueToUi: function () {
                if (this.value === null) {
                    return;
                }

                var slider = $(this.element).find('.slider');

                if (!_.isEqual(this.value, this._convertToValue(slider.xslider('xvalues')))) {
                    var sliderVal = this._convertToSlider(this.value);
                    slider.xslider('xvalues', sliderVal);

                    this._updateLabel(sliderVal);
                }
            },
            getValueFromUi: function () {

            },

            _convertToValue: function(values) {
                var minVal = (values[0] * this._maxValue) / 100;
                var maxVal = (values[1] * this._maxValue) / 100;

                return [minVal, maxVal];
            },

            _convertToSlider: function(values) {
                var minVal = (values[0] * 100) / this._maxValue;
                var maxVal = (values[1] * 100) / this._maxValue;

                return [minVal, maxVal];
            }
        });

        return RatingSliderRangeFilterWidget;
    }
);



// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/ratingslider/ratingSliderRangeWidget.js